export default __webpack_public_path__ + "static/3-0e9cc6c13be7f2c9720208fb4aa77622.jpeg";